import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import "../index.css"

// Inputs
import { TextInputField, AutoCompleteField, ChipsField, TextAreaField } from '../../../helpers'
import { Toast } from 'primereact/toast'


// utils
import { sortArrayOfObjectsInAlphabeticalOrder } from '../../../utils';

import { raiseToast } from '../../../services/redux/reducers/toast/toast';

// redux apis
import { fetchMaterialProductsByCategoryId, fetchMaterialProductsUOMsByCategoryId } from '../../../services/redux/reducers/materialMaster/materialMaster'

const ApprovalMaterialItem = (props) => {
    const dispatch = useDispatch()

    const { approvalMaterialItem } = props

    const [isVariantProductUOM, setIsVariantProductUOM] = useState(true)

    // suggestions states
    const [searchedMaterialCategory, setSearchedMaterialCategory] = useState([])
    const [searchedmaterialBrands, setSearchedmaterialBrands] = useState([])
    const [searchedmaterialUOMs, setSearchedmaterialUOMs] = useState([])
    const [searchedProductNames, setSearchedProductNames] = useState([])
    const [searchedVariantNames, setSearchedVariantNames] = useState([])
    const [searchedMaterialSpecifications, setSearchedMaterialSpecifications] = useState([])

    // constant default data
    const materialCategory = useSelector((state) => state.common.materialCategories)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const materialUOMData = useSelector(state => state.common.materialUOMs)
    const materialProductsByCaterogy = useSelector(state => state.materialMaster.materialProductsByCaterogy)

    const searchCategory = (event) => {
        const relatedCategory = materialCategory.filter(category => category.categoryName.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedMaterialCategory([...relatedCategory])
    }

    const searchBrands = (event) => {
        const relatedBrand = materialBrands.filter(brand => brand.brandName.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialBrands([...relatedBrand])
    }

    const searchUOMs = (event) => {
        const relatedUOMs = materialUOMData.filter(materialUOM => materialUOM.UOM.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialUOMs([...relatedUOMs])
    }

    const searchProductNames = (event) => {
        let productNames = []
        const relatedProductNames = materialProductsByCaterogy.filter(product => {
            if(product.productName?.toLowerCase().includes(event.query.trim()?.toLowerCase())){
                if(!productNames.includes(product.productName?.toLowerCase())){
                    productNames.push(product.productName?.toLowerCase())
                    return true
                }
            }
        })

        setSearchedProductNames([...relatedProductNames])
    }

    const searchVariantNames = (event) => {
        let variantNames = []
        const relatedVariantNames = props.materialVariantProducts.filter(product => {
            if(product.variantName?.toLowerCase().includes(event.query.trim()?.toLowerCase())){
                if(!variantNames.includes(product.variantName?.toLowerCase())){
                    variantNames.push(product.variantName?.toLowerCase())
                    return true
                }
            }
        })

        setSearchedVariantNames([...relatedVariantNames])
    }

    const searchMaterialSpecification = (event) => {
        const relatedMaterialSpecification = props.materialSpecification.filter(specification => specification.productSpecification?.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedMaterialSpecifications([...relatedMaterialSpecification])
    }

    const handleCopyPaste = (e) => {
        e.preventDefault()
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    }

    const handleDrop = (e) => {
        e.preventDefault();
    }

    const handleInputChange = (event) => {

        if(typeof (event.target.value) === "object"){
            approvalMaterialItem[event.target.name] = event.target.value
        }
        else{
            if(event.target.name === 'remarks' || event.target.name === "categoryId" || event.target.name === "brandId"){
                approvalMaterialItem[event.target.name] = event.target.value
            }else{
                approvalMaterialItem[event.target.name] = event.target.value?.toUpperCase()
            }
        }

        if (event.target.value != null) {
            if (event.target.name === "categoryId") {

                approvalMaterialItem["productName"] = ""
                approvalMaterialItem["variantName"] = ""
                approvalMaterialItem["productSpecification"] = ""
                approvalMaterialItem["UOM"] = ""
                approvalMaterialItem["UOMValue"] = ""
                approvalMaterialItem['keywords'] = []

                if (typeof (event.target.value) === "object") {
                    dispatch(fetchMaterialProductsByCategoryId(event.target.value.categoryId))
                    dispatch(fetchMaterialProductsUOMsByCategoryId(event.target.value.categoryId))
                }else{
                    const relatedCategory = materialCategory.find(category => category.categoryName.toLowerCase() === event.target.value?.trim().toLowerCase())
                    if(relatedCategory){
                        approvalMaterialItem[event.target.name] = relatedCategory
                        dispatch(fetchMaterialProductsByCategoryId(relatedCategory.categoryId))
                        dispatch(fetchMaterialProductsUOMsByCategoryId(relatedCategory.categoryId))
                    }
                }

                props.setMaterialSpecification([])
                props.setMaterialSpecificationAttributes([])
            }
            
            if (event.target.name === "productName") {

                let relatedVariantNames = []
                if (typeof (event.target.value) === "object") {
                    relatedVariantNames = props.materialProductsByCaterogy.filter(product => product?.productName.toLowerCase() === event.target.value.productName?.trim()?.toLowerCase())
                }
                else {
                    relatedVariantNames = props.materialProductsByCaterogy.filter(product => product?.productName.toLowerCase() === event.target.value?.trim().toLowerCase())
                }
                
                let sortedVariantNames = sortArrayOfObjectsInAlphabeticalOrder(relatedVariantNames, "variantName")
                
                props.setMaterialVariantProducts(sortedVariantNames)
                props.setMaterialSpecification([])

                const relatedMaterialProductUOM = props.materialProductsUOMsByCaterogy?.find(product => {
                    let productName = ""
                    let variantName = ""
                    if (typeof (approvalMaterialItem.productName) === "object") {
                        productName = approvalMaterialItem.productName.productName?.trim()?.toLowerCase()
                    }
                    else {
                        productName = approvalMaterialItem.productName?.trim()?.toLowerCase()
                    }

                    if (typeof (approvalMaterialItem.variantName) === "object") {
                        variantName = approvalMaterialItem.variantName.variantName?.trim()?.toLowerCase()
                    }
                    else {
                        variantName = approvalMaterialItem.variantName?.trim()?.toLowerCase()
                    }

                    if (product.productName.toLowerCase() === productName && product.variantName.toLowerCase() === variantName) {
                        return true
                    }
                })

                approvalMaterialItem["variantName"] = ""
                approvalMaterialItem["UOMValue"] = ""

                if (relatedMaterialProductUOM) {
                    approvalMaterialItem["UOM"] = relatedMaterialProductUOM.UOM
                    setIsVariantProductUOM(true)
                } else {
                    approvalMaterialItem["UOM"] = ''
                    setIsVariantProductUOM(false)
                }
            }
            if (event.target.name === "variantName") {
                let relatedProductSpecifications = []
                if (typeof (event.target.value) === "object") {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === event.target.value.variantName?.trim()?.toLowerCase())
                }
                else {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === event.target.value?.trim()?.toLowerCase())
                }
                
                let relatedMaterialSpecificationSOPs = relatedProductSpecifications.filter(specification => specification.materialSpecificationId)
                let relatedSpecifications = relatedProductSpecifications.filter(specification => !specification.materialSpecificationId)
                
                if (relatedMaterialSpecificationSOPs.length > 0) {
                    let specificationAttributes = []
                    relatedMaterialSpecificationSOPs.map(specification => {
                        let attributeObj = {
                            name: specification.attribute,
                            mandatory: specification.materialSpecificationMandatoryTypeId,
                            //unit: specification.attributeUnit
                        }
                        if(specification.attributeUnit){
                            attributeObj.unit = specification.attributeUnit
                        }
                        specificationAttributes.push(attributeObj)
                    })
                    props.setMaterialSpecificationAttributes(specificationAttributes)
                    props.setMaterialSpecification([...relatedMaterialSpecificationSOPs])
                }
                else {
                    props.setMaterialSpecificationAttributes([])
                    props.setMaterialSpecification([...relatedSpecifications])
                }

                const relatedMaterialProductUOM = props.materialProductsUOMsByCaterogy?.find(product => {
                    let productName = ""
                    let variantName = ""
                    if (typeof (approvalMaterialItem.productName) === "object") {
                        productName = approvalMaterialItem.productName.productName?.trim()?.toLowerCase()
                    }
                    else {
                        productName = approvalMaterialItem.productName?.trim()?.toLowerCase()
                    }

                    if (typeof (approvalMaterialItem.variantName) === "object") {
                        variantName = approvalMaterialItem.variantName.variantName?.trim()?.toLowerCase()
                    }
                    else {
                        variantName = approvalMaterialItem.variantName?.trim()?.toLowerCase()
                    }

                    if (product.productName.toLowerCase() === productName && product.variantName.toLowerCase() === variantName) {
                        return true
                    }
                })

                approvalMaterialItem["productSpecification"] = ""
                approvalMaterialItem["UOMValue"] = ""

                if (relatedMaterialProductUOM) {
                    approvalMaterialItem["UOM"] = relatedMaterialProductUOM.UOM
                    setIsVariantProductUOM(true)
                } else {
                    approvalMaterialItem["UOM"] = ''
                    setIsVariantProductUOM(false)
                }
            }
        }
        props.setapprovalMaterialItem({ ...approvalMaterialItem })
    }

    let relatedMaterialSpecifications = []
    
    return (
        <div className="">
            <Toast ref={Toast} />
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="categoryId" labelText="Category" field="categoryName" placeholder="Search category" value={approvalMaterialItem.categoryId} suggestions={searchedMaterialCategory} searchMethod={searchCategory} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown forceSelection disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="brandId" labelText="Brand" field="brandName" placeholder="Search brand" value={approvalMaterialItem.brandId} suggestions={searchedmaterialBrands} searchMethod={searchBrands} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown forceSelection disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="productName" labelText="Product name" field="productName" placeholder="Search name" value={approvalMaterialItem.productName} suggestions={searchedProductNames} searchMethod={searchProductNames} onChange={(e) => handleInputChange(e)} onPaste={(e)=>handleCopyPaste(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="variantName" labelText="Variant name" field="variantName" placeholder="Search variant" value={approvalMaterialItem.variantName} suggestions={searchedVariantNames} searchMethod={searchVariantNames} onChange={(e) => handleInputChange(e)} onPaste={(e)=>handleCopyPaste(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled />
                </div>
                {
                    relatedMaterialSpecifications.length > 0 && relatedMaterialSpecifications.map((specification, index) => {
                        return (
                            <div key={`materialSpecificatin-${specification.specificationId}-${index}`} className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name={specification.attribute} labelText={`${specification.attribute} ( Unit: ${specification.attributeUnit ? specification.attributeUnit : "NA"} )`} value={approvalMaterialItem[specification.attribute]} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} disabled />
                            </div>
                        )
                    })
                }
                {
                    relatedMaterialSpecifications.length === 0 && <div className="flex flex-column col-12 mb-2 lg:col-9 lg:mb-0">
                        <AutoCompleteField name="productSpecification" labelText="Product Specification" field="productSpecification" placeholder="Search specification" value={approvalMaterialItem.productSpecification} suggestions={searchedMaterialSpecifications} searchMethod={searchMaterialSpecification} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled />
                    </div>
                }
                <div className="flex col-3 pl-0 pt-0 lg:col-3 lg:mb-0">
                    <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                        <TextInputField name="UOMValue" labelText="UOM Value" keyfilter={"pnum"} value={approvalMaterialItem.UOMValue} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} disabled />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                        <AutoCompleteField name="UOM" labelText="UOM" field="UOM" placeholder="UOM" value={approvalMaterialItem.UOM} suggestions={searchedmaterialUOMs} searchMethod={searchUOMs} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled forceSelection />
                    </div>
                </div>
            </div>
            <div className="grid my-2 mx-2">
                <div className="flex flex-column col-7 pl-0 pt-0">
                    <div className="flex flex-column col-12">
                        <ChipsField name="keywords" labelText="Keywords" onChange={(e) => handleInputChange(e)} value={approvalMaterialItem.keywords} disabled />
                    </div>
                    <div className="flex flex-column col-12 text-area">
                        <TextAreaField name="remarks" labelText="Remarks" rows={3} onChange={(e) => handleInputChange(e)} value={approvalMaterialItem.remarks} disabled />
                    </div>
                    {
                        approvalMaterialItem.productDescription &&
                        <div className="flex flex-column col-12 text-area mb-2">
                            <TextAreaField name="productDescription" labelText="Product Description" placeholder="Please enter product description" maxLength={500} rows={3} autoResize value={approvalMaterialItem.productDescription} disabled />
                        </div>
                    }
                </div>
                <div className="flex flex-column col-5 align-items-start">
                    {approvalMaterialItem.materialImage?.length > 0 && <h4 className="mt-0 ml-2 mb-2">Material Images</h4>}
                    <div className='' style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem' }}>
                        {
                            approvalMaterialItem.materialImage?.length > 0 ? approvalMaterialItem.materialImage?.map(image => {
                                let isThumbnailImage = image === approvalMaterialItem.thumbnailImage
                                return (
                                    <div key={image.imageId} className='prod-image-container'>
                                        <div className=''>
                                            <img
                                                src={image}
                                                alt="Preview"
                                                className="prod-image"
                                                style={{ border: isThumbnailImage ? '2px solid #00baaa' : '1px solid #ccc', boxShadow: isThumbnailImage ? '0 0 10px rgba(0, 255, 0, 0.5)' : 'none', borderRadius: "3px", objectFit: 'cover' }}
                                            />
                                        </div>
                                    </div>
                                )
                            }) : ""
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApprovalMaterialItem;